<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-30 11:06:01
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\ApprovalProcess.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 15:42:03
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_approvalProcess_list_title')"
    pad="0"
    @activated="activated"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber
        special
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        @filter="
          (val, tab) => {
            if (tab == 1) {
              filterPageData1 = val;
            } else filterPageData2 = val;
          }
        "
      >
        <!-- 筛选 -->
        <template v-slot:filter-content-1="{ filter }">
          <div v-show="curTab === 'tab-1'">
            <Selections2
              :objects="filterObjects"
              small-chip
              @filter="
                filter();
                toFilter(1, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects, null, null);
                  if (apply) {
                    filter();
                    toFilter(1, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-2="{ filter }">
          <div v-show="curTab === 'tab-2'">
            <!-- 筛选 -->
            <Selections2
              :objects="filterObjects2"
              small-chip
              @filter="
                filter();
                toFilter(2, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects2, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects2, null, null);
                  if (apply) {
                    filter();
                    toFilter(2, filter);
                  }
                }
              "
            />
          </div>
        </template>

        <template v-slot:content-1>
          <Tabler
            :headers="headers"
            :filter-page-data="filterPageData1"
            :items="desserts1"
            :height="$vuetify.breakpoint.height - 335"
            :totalCount="totalCount1"
            @change="
              (page, perpage, callback, data) => {
                getList(1, data, page, perpage, callback);
              }
            "
            overLoading
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item
                  dense
                  two-line
                  class="pa-0 ma-0"
                  v-if="item.agent_staff"
                >
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      size="36"
                      :isTemp="item.agent_staff.is_temp"
                      :src="item.agent_staff.staff_avatar"
                      :staff_name="item.agent_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{
                        $getCommonLangValue(item.agent_staff.preferred_name)
                      }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.agent_staff.staff_code }}</span
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      $getCommonLangValue(item.agent_staff.job_post_name)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.approver="{ item }">
              <div style="max-width: 300px">
                <v-list-item
                  dense
                  two-line
                  class="pa-0 ma-0"
                  v-if="item.approved_staff"
                >
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      size="36"
                      :isTemp="item.approved_staff.is_temp"
                      :src="item.approved_staff.staff_avatar"
                      :staff_name="item.approved_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{
                        $getCommonLangValue(item.approved_staff.preferred_name)
                      }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.approved_staff.staff_code }}</span
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      $getCommonLangValue(item.approved_staff.job_post_name)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.swift_number="{ item }">
              <div class="text--primary table-title">
                {{ item.swift_number }}
              </div>
            </template>
            <template v-slot:item.application="{ item }">
              <div
                class="text--primary table-title"
                :title="$getCommonLangValue(item.title)"
              >
                {{ $getCommonLangValue(item.title) }}
                <span v-if="Number(item.cancel_flag) == 1"
                  >({{
                    $t("label_essweb_LeaveApplication_list_tag_cancelLabel")
                  }})</span
                >
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              <div class="text--primary table-title">
                {{ $getDateTime(item.apply_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                v-if="hasBtn('view-approval-process')"
                icon
                @click="toView(item.data_type, item, item.cancel_flag)"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :filter-page-data="filterPageData2"
            :items="desserts2"
            :height="$vuetify.breakpoint.height - 335"
            overLoading
            :totalCount="totalCount2"
            @change="
              (page, perpage, callback, data) => {
                getList(2, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item
                  dense
                  two-line
                  class="pa-0 ma-0"
                  v-if="item.agent_staff"
                >
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      size="36"
                      :isTemp="item.agent_staff.is_temp"
                      :src="item.agent_staff.staff_avatar"
                      :staff_name="item.agent_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{
                        $getCommonLangValue(item.agent_staff.preferred_name)
                      }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.agent_staff.staff_code }}</span
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      $getCommonLangValue(item.agent_staff.job_post_name)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.swift_number="{ item }">
              <div class="text--primary table-title">
                {{ item.swift_number }}
              </div>
            </template>
            <template v-slot:item.approver="{ item }">
              <div style="max-width: 300px">
                <v-list-item
                  dense
                  two-line
                  class="pa-0 ma-0"
                  v-if="item.approved_staff"
                >
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      size="36"
                      :isTemp="item.approved_staff.is_temp"
                      :src="item.approved_staff.staff_avatar"
                      :staff_name="item.approved_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{
                        $getCommonLangValue(item.approved_staff.preferred_name)
                      }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.approved_staff.staff_code }}</span
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      $getCommonLangValue(item.approved_staff.job_post_name)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.application="{ item }">
              <div
                class="text--primary table-title"
                :title="$getCommonLangValue(item.title)"
              >
                {{ $getCommonLangValue(item.title) }}
                <span v-if="Number(item.cancel_flag) == 1"
                  >({{
                    $t("label_essweb_LeaveApplication_list_tag_cancelLabel")
                  }})</span
                >
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              <div class="text--primary table-title">
                {{ $getDateTime(item.apply_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                v-if="hasBtn('view-approval-process')"
                icon
                @click="toView(item.data_type, item, item.cancel_flag)"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template> </Taber
    ></template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ApprovalProcess",
  computed: {
    ...mapGetters(["SelectionRefresh"]),
  },
  watch: {
    SelectionRefresh(v) {
      if (v === 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
      }
    },
  },
  data() {
    return {
      totalCount2: 0,
      filterPageData1: null,
      filterPageData2: null,
      totalCount1: 0,
      curTab: "tab-1",
      taber: [
        "label_essweb_approvalProcess_list_tab_underReviewLabel",
        "label_essweb_approvalProcess_list_tab_completeLabel",
      ],
      desserts1: [],
      desserts2: [],
      headers: [
        {
          text: "label_essweb_leaveApplication_form_swiftNumberLabel",
          value: "swift_number",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_approvalProcess_list_applicantLabel",
          value: "applicant",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_approvalProcess_list_approverLabel",
          value: "approver",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_approvalProcess_list_applicationLabel",
          value: "application",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_approvalProcess_list_submitDateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_approvalProcess_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_leaveApplication_form_swiftNumberLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "applicant",
          avatar: true,
          twoLine: true,
          multiple: true,
          label: "label_essweb_approvalProcess_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "string",
          sequence: 3,
          name: "application_type",
          position: "right",
          label: "label_essweb_approvalApplication_list_applicantionLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "daterange",
          sequence: 4,
          name: "date",
          position: "right",
          label: "label_essweb_approvalProcess_list_submitDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 5,
          position: "right",
          name: "status",
          statusChip: "approval",
          multiple: true,
          label: "label_essweb_approvalProcess_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 6,
          position: "right",
          showKey: "dict_label",
          name: "applicant_staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_applicatJobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 7,
          position: "right",
          showKey: "dict_label",
          name: "approver_staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_approvalJobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      filterObjects2: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_leaveApplication_form_swiftNumberLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "applicant",
          avatar: true,
          twoLine: true,
          multiple: true,
          label: "label_essweb_approvalProcess_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "string",
          sequence: 3,
          name: "application_type",
          position: "right",
          label: "label_essweb_approvalApplication_list_applicantionLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "daterange",
          sequence: 4,
          name: "date",
          position: "right",
          label: "label_essweb_approvalProcess_list_submitDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 5,
          position: "right",
          name: "status",
          statusChip: "approval",
          multiple: true,
          label: "label_essweb_approvalProcess_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 6,
          position: "right",
          showKey: "dict_label",
          name: "applicant_staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_applicatJobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 7,
          position: "right",
          showKey: "dict_label",
          name: "approver_staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_approvalJobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      first: false,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    // this.getList(1, null, 1, this.$tableSetting.perPageSize, null);
    // this.getList(2, null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
        // if (this.page !== null) {
        this.desserts1 = [];
        this.desserts2 = [];
        this.curTab = "tab-1";
        this.getList(1, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.getList(2, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.first = true;
      }
      if (refresh == 1) {
        this.curTab = "tab-1";
        if (this.filterPageData1 || this.filterPageData2) {
          let page1 = 1,
            page2 = 1,
            pagesize1 = null,
            pagesize2 = null;
          if (this.filterPageData1 && this.filterPageData1["data"]) {
            page1 = this.filterPageData1["data"]["cpage"]
              ? this.filterPageData1["data"]["cpage"]
              : 1;
            pagesize1 = this.filterPageData1["data"]["pagesize"]
              ? this.filterPageData1["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData2 && this.filterPageData2["data"]) {
            page2 = this.filterPageData2["data"]["cpage"]
              ? this.filterPageData2["data"]["cpage"]
              : 1;
            pagesize2 = this.filterPageData2["data"]["pagesize"]
              ? this.filterPageData2["data"]["pagesize"]
              : null;
          }
          this.toFilter(1, () => {}, page1, pagesize1);
          this.toFilter(2, () => {}, page2, pagesize2);
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(2, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toView: function (data_type, item, cancel_flag) {
      const that = this;
      switch (Number(data_type)) {
        case 1:
          that.$toPage(
            "/admin/approval-process/leave-detail/" +
              this.$aesEncrypt(
                JSON.stringify({
                  id: item.uuid,
                  cancel_flag: cancel_flag,
                })
              )
          );
          break;
        case 2:
          that.$toPage(
            "/admin/approval-process/claim-detail/" +
              this.$aesEncrypt(
                JSON.stringify({
                  id: item.uuid,
                })
              )
          );
          break;

        case 3:
          that.$toPage(
            "/admin/approval-process/roster-detail/" +
              this.$aesEncrypt(
                JSON.stringify({
                  id: item.uuid,
                })
              )
          );
          break;
        case 4:
          that.$toPage(
            "/admin/approval-process/abnormalClockin-detail/" +
              this.$aesEncrypt(
                JSON.stringify({
                  id: item.uuid,
                })
              )
          );
          break;
        case 5:
          that.$toPage(
            "/admin/approval-process/attendance-detail/" +
              this.$aesEncrypt(
                JSON.stringify({
                  id: item.uuid,
                })
              )
          );
          break;
        case 6:
          that.$toPage(
            "/admin/approval-process/custom-form-detail/" +
              this.$aesEncrypt(
                JSON.stringify({
                  id: item.uuid,
                })
              )
          );
          break;
        default:
          break;
      }
    },
    toFilter(tab, callback, page, pagesize) {
      const that = this;
      let object = [];
      if (tab == 1) {
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else {
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      }

      let data = {
        flow_status: tab,
        list_type: 2,
        add_staff: 1,
      };
      object.map((item) => {
        if (item["name"] == "applicant")
          data["applicant_staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "approver")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "application_type") {
          data["title"] = item.value;
        }
        if (item["name"] == "swift_number") {
          data["application_swift_number"] = item.value;
        }
        if (item["name"] == "status") {
          data["status_detail"] = item.value.join(",");
        }
        if (item["name"] == "applicant_staff_status")
          data["applicant_staff_status"] = item.value
            ? item.value.join(",")
            : "";
        if (item["name"] == "approver_staff_status")
          data["approver_staff_status"] = item.value
            ? item.value.join(",")
            : "";
      });
      if (!page) {
        this.getList(tab, data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          tab,
          data,
          page ? page : 1,
          pagesize ? pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (flow_status, data, page, perpage, callback) {
      const that = this;
      if (page !== 1) this.page = page;
      else this.page = null;
      if (perpage !== this.$tableSetting.perPageSize) this.pagesize = perpage;
      else this.pagesize = null;
      this.selected = [];
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval-task/get-approval-task-list/",
        data: data
          ? data
          : {
              flow_status: flow_status,
              list_type: 2,
              add_staff: 1,
              cpage: page,
              pagesize: perpage,
            },
      })
        .then((res) => {
          if (flow_status == 1) {
            that.desserts1 = res.data;
            that.totalCount1 = res.totalcount;
          }
          if (flow_status == 2) {
            that.desserts2 = res.data;
            that.totalCount2 = res.totalcount;
          }
          callback ? callback(page, perpage, data, flow_status) : null;
        })
        .catch(() => {
          callback ? callback(page, perpage, data, flow_status) : null;
        });
    },
  },
};
</script>